module.exports = __webpack_public_path__ + "static/c_2-383546db736fb83688648d5f8449bbd5.jpg";